<template>
  <v-container grid-list-lg>
    <v-row wrap v-if="grup">
      <v-col cols="12">
        <m-card pa-0 ma-0 title="Detail Grup">
          <v-row wrap pa-0 ma-0>
            <v-col cols="12" sm="12" md="12">
              <v-subheader class="title primary--text">Informasi</v-subheader>
              <v-list-item two-line class="py-0">
                <v-list-item-content>
                  <v-list-item-title class="caption">Nama</v-list-item-title>
                  <v-list-item-subtitle
                    >&nbsp;{{ pVal(grup, "nama") }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line class="py-0">
                <v-list-item-content>
                  <v-list-item-title class="caption"
                    >Keterangan</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >&nbsp;{{ pVal(grup, "keterangan") }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col pa-0 ma-0>
              <m-card-list
                two-line
                title="Anggota"
                label-cari="Cari Anggota"
                :headers="headers"
                :page="page"
                :items="grup.members"
                :perPage="grup.members.length"
                item-key="user_id"
                footer
              >
                <template v-slot:items="{ props, item }">
                  <tr v-if="$vuetify.breakpoint.smAndUp">
                    <td>{{ pVal(item, "nama") }}</td>
                    <td>
                      {{
                        (item && item.no_pegawai) ||
                        "-"
                      }}
                    </td>
                    <td>
                      <v-chip
                        small outlined
                        :color="item.is_face_verified ? 'green' : 'red'"
                      >
                        {{
                          item.is_face_verified
                            ? "Terverifikasi"
                            : "Belum Verifikasi"
                        }}
                      </v-chip>
                    </td>
                  </tr>
                  <tr v-else>
                    <td class="v-data-table__mobile-row">
                      <div class="v-data-table__mobile-row__wrapper">
                        <div class="v-data-table__mobile-row__header">
                          {{ headers[0].text }}
                        </div>
                        <div class="v-data-table__mobile-row__cell">
                          {{ pVal(item, "nama") }}
                        </div>
                      </div>
                    </td>
                    <td class="v-data-table__mobile-row">
                      <div class="v-data-table__mobile-row__wrapper">
                        <div class="v-data-table__mobile-row__header">
                          {{ headers[1].text }}
                        </div>
                        <div class="v-data-table__mobile-row__cell">
                          {{
                            (item && item.no_pegawai) ||
                            "-"
                          }}
                        </div>
                      </div>
                    </td>
                    <td class="v-data-table__mobile-row">
                      <div class="v-data-table__mobile-row__wrapper">
                        <div class="v-data-table__mobile-row__header">
                          {{ headers[2].text }}
                        </div>
                        <div class="v-data-table__mobile-row__cell"></div>
                      </div>
                    </td>
                  </tr>
                </template>
              </m-card-list>
            </v-col>
          </v-row>
        </m-card>
        <ChangeDlg ref="dlg" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ChangeDlg from "../components/Form.vue";
export default {
  components: {
    ChangeDlg
  },
  data() {
    return {
      grup: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "NIP", align: "left", value: "no_pegawai" },
        {
          text: "Verifikasi Wajah",
          align: "left",
          value: "is_face_verification"
        }
      ],
      pagination: {
        sortBy: "nama"
      }
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      if(!this.isCan('group.get-members')) return
      this.$store
        .dispatch("grup/getMember", this.$route.params.group_id)
        .then(res => {
          this.grup = res.data;
        })
        .catch(e => e);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    edit() {
      this.$refs.dlg.open(this.grup).then(() => {
        this.load();
      });
    },
    close() {
      this.$router.push({
        name: "grup"
      });
    }
  }
};
</script>
<style scoped>
  .elevation-custom{
  -webkit-box-shadow: 0px 0px 20px 3px #4362be56 !important;
}
</style>
